// LEGAL1-F1 (docs/build-briefs/LEGAL1-F1-in-app-legal-links.md). The one place the in-force Terms of Service and Privacy
// Policy version is named. A new owner's agreement is recorded against this version, the server refuses any other, and the
// links the sign-in screens and footers show are the two addresses below. Change the version here when counsel publishes
// new text; nothing else in the code names it. Dependency free so the browser bundles can import it too.

export const LEGAL_TERMS_VERSION = "2026-10-21";
export const LEGAL_PRIVACY_URL = "https://snipsip.com/privacy/";
export const LEGAL_TERMS_URL = "https://snipsip.com/terms/";

/** True when a client sent exactly the version in force. */
export function isCurrentTermsVersion(value: unknown): boolean {
  return value === LEGAL_TERMS_VERSION;
}
